<template>
    <el-time-select
        ref="component"
        class="day-time-select"
        v-model="time"
        :clearable="false"
        :picker-options="pickerOptions"
        @change="onTimePickerChange"
        @keyup.enter.native="onEnter($refs.component)"
        @keydown.native="onKeyDown"
        @blur="onTimePickerBlur"
        :placeholder="placeholder"
        :size="size"
    ></el-time-select>
</template>

<script>
import moment from 'moment';

export default {
    name: 'timepicker',
    props: {
        value: null,
        placeholder: {
            type: String,
            default() {
                return this.$t('End time');
            },
        },
        size: {
            type: String,
            default() {
                return 'small';
            },
        },
        pickerOptions: {
            type: Object,
            default() {
                return {
                    start: '00:00',
                    step: '00:15',
                    end: '23:59',
                };
            },
        },
    },
    computed: {
        time: {
            get() {
                if (moment(this.value).isValid()) {
                    return moment(this.value).format(this.$store.getters.timeDisplayFormat);
                }
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
                this.$emit('change', value);
            },
        },
    },
    methods: {
        onTimePickerBlur(comp) {
            const enteredValue = comp.refInput[0].value;
            let format = null;
            let value = null;
            const re = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

            if (enteredValue.indexOf(':') === -1 && !Number.isNaN(parseFloat(enteredValue))) {
                if (enteredValue.length === 1) {
                    format = 'H';
                } else if (enteredValue.length === 2) {
                    format = 'HH';
                } else if (enteredValue.length === 3) {
                    format = 'Hmm';
                } else {
                    format = 'HHmm';
                }

                value = moment(enteredValue, format).format('HH:mm');
                this.time = value;
            } else if (re.test(enteredValue)) {
                this.time = enteredValue;
            }
        },
        onEnter(comp) {
            this.onTimePickerBlur(comp);
            this.$nextTick(() => {
                comp.refInput[0].value = this.time;
            });
        },
        onTimePickerChange(enteredValue) {
            this.time = enteredValue;
            this.$refs.component.refInput[0].value = this.time;
        },
        onKeyDown(evt) {
            const { value } = this.$refs.component.refInput[0];
            if (
                (value.length === 4 && value.indexOf(':') === -1) ||
                (value.length > 5 && value.indexOf(':') > -1)
            ) {
                evt.preventDefault();
            }
        },
    },
};
</script>
